import React from 'react';
import { Link } from 'react-router-dom';

const MobileMenu = ({ isOpen, onToggle, currentPage, onLoginClick, navigationLinks }) => {
  const handleLinkClick = () => {
    // Close mobile menu when a link is clicked
    onToggle();
  };

  return (
    <div className={`mobile-menu ${isOpen ? 'mobile-menu-open' : ''}`}>
      <div className="mobile-menu-overlay" onClick={onToggle}></div>
      <div className="mobile-menu-content">
        <div className="mobile-menu-header">
          <button className="mobile-menu-close" onClick={onToggle}>
            ×
          </button>
        </div>
        
        <nav className="mobile-menu-nav">
          <ul className="mobile-nav-list">
            {navigationLinks.map((link, index) => (
              <li 
                key={index}
                className={`mobile-nav-item ${currentPage === link.path ? 'active' : ''}`}
              >
                <Link 
                  to={link.path}
                  className="mobile-nav-link"
                  onClick={handleLinkClick}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          
          <div className="mobile-menu-actions">
            <Link 
              to="/auth/login"
              className="mobile-login-btn"
              onClick={handleLinkClick}
            >
              <img
                alt="Login"
                src="/assets/images/padlock.png"
              />
              <span>Login</span>
            </Link>
            <Link 
              to="/auth/register"
              className="mobile-join-btn"
              onClick={handleLinkClick}
            >
              <span>Join Now</span>
            </Link>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;